// extracted by mini-css-extract-plugin
export default {"layout-main":"protectedRouteLayout_layout-main__gD9vq"};